import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CalendarDays, ChevronRight } from 'lucide-react';

export const PersonScheduledLive = ({ live, username }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('lives');
  if (!live?.id || !live.starts_at) return null;
  return <button type="button" onClick={(e) => { e.stopPropagation(); navigate(`/lives/${live.id}`); }}
    onKeyDown={(e) => e.stopPropagation()}
    className="mt-4 flex w-full min-w-0 items-center gap-3 rounded-lg border border-amber-400/50 bg-amber-400/10 px-3 py-3 text-left transition-colors hover:bg-amber-400/20"
    data-testid={`person-next-live-${username}`}>
    <CalendarDays className="h-5 w-5 shrink-0 gold-text" />
    <span className="min-w-0 flex-1">
      <span className="block text-xs font-semibold gold-text" data-testid={`person-next-live-date-${username}`}>
        {new Date(live.starts_at).toLocaleString(undefined, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
      </span>
      <span className="mt-0.5 block truncate text-sm font-medium" data-testid={`person-next-live-title-${username}`}>{live.title}</span>
      <span className="mt-1 block text-xs text-muted-foreground">{t('schedule.view_live')}</span>
    </span>
    <ChevronRight className="h-4 w-4 shrink-0 gold-text" />
  </button>;
};